// extracted by mini-css-extract-plugin
module.exports = {"root":"Rank_root__Ghbde","title":"Rank_title__gQ_fn","text":"Rank_text__KFlTn","ranks":"Rank_ranks__lfcYJ","img":"Rank_img__xsoMv"};